import { Trans } from "next-i18next";

import { LINKS } from "@/constants/links";
import useUrl from "@/hooks/useUrl";
import { TServerError } from "@/types/api/shared";

import { Message } from "../elements/Message";

export type ServerErrorProps = {
  error: TServerError | null;
  className?: string;
};

export const ServerError = ({ error, className }: ServerErrorProps) => {
  const { langPathPrefix } = useUrl();

  if (!error?.message) return;

  return (
    <Message type="error" className={className}>
      <Trans
        ns={"common"}
        i18nKey={[
          `errors.server.${error.message}`,
          error.message,
          "errors.server.generic",
        ]}
        components={{
          accountLink: (
            <a href={`${langPathPrefix}${LINKS.ACCOUNT_EDIT}`}>account</a>
          ),
          faqLink: <a href={`${langPathPrefix}/sporsmal-og-svar`}>FAQ</a>,
          vippsLink: <a href="https://status.vippsmobilepay.com/">Vipps</a>,
          maxOrder: <span style={{ display: "block" }}>MaxOrder</span>,
        }}
      />
    </Message>
  );
};
